import type { GetConversationSandboxResponseBody } from "@app/lib/api/assistant/conversation/sandbox";
import { useFetcher, useSWRWithDefaults } from "@app/lib/swr/swr";
import type { LightWorkspaceType } from "@app/types/user";
import type { Fetcher } from "swr";

export function useConversationSandboxStatus({
  conversationId,
  owner,
  options,
}: {
  conversationId?: string | null;
  owner: LightWorkspaceType;
  options?: { disabled?: boolean };
}) {
  const { fetcher } = useFetcher();
  const sandboxFetcher: Fetcher<GetConversationSandboxResponseBody> = fetcher;

  const { data, error, mutate } = useSWRWithDefaults(
    conversationId
      ? `/api/w/${owner.sId}/assistant/conversations/${conversationId}/sandbox`
      : null,
    sandboxFetcher,
    options
  );

  const disabled = options?.disabled;

  return {
    sandboxStatus: data?.sandboxStatus ?? null,
    isSandboxStatusLoading: !disabled && !error && !data,
    mutateSandboxStatus: mutate,
  };
}
